$ = jQuery.noConflict();

$(document).ready(function () {
  if (window.location.hash) {
    const hash = window.location.hash;
    const $tabs_section = $('#tabs-section');
    let tabPosition;
    if ($tabs_section.is(':visible')) {
      const $tab = $tabs_section.find('.tab a[href="' + hash + '"]').closest('.tab');
      tabPosition = $tabs_section.offset().top - $('header.main-header').outerHeight();
      make_tab_active($tab);
    } else {
      const $link = $('#tab-panels-section a.tab-accordion-button[href="' + hash + '"]');
      tabPosition = $link.offset().top - $('header.main-header').outerHeight();
      make_accordion_active($link)
    }
    $('html, body').animate({ scrollTop: tabPosition }, 'slow');
  } else {
    $('.tab-panel:not(:first)').hide();
  }

  $('.tabs .tab').on('click', function (e) {
    e.preventDefault();
    make_tab_active($(this));
  });

  $('.tab-accordion-button').on('click', function (e) {
    e.preventDefault();
    make_accordion_active($(this));
  });
});

function make_tab_active($tab) {
  $('.tabs .tab').removeClass('active');
  $tab.addClass('active');
  $('.tab-panel').hide();
  const href = $tab.find('a').attr('href');
  $(href).show();
  // $tab.attr('tabindex',0).focus();
  history.pushState(null, null, href);
}
function make_accordion_active($tab) {
  const $content = $tab.next('.tab-content');

  if ($tab.hasClass('active')) {
    $tab.removeClass('active');
    $content.slideUp();
  } else {
    $('.tab-panel .tab-content').slideUp();
    $('.tab-accordion-button').removeClass('active');
    $tab.addClass('active');
    $content.slideDown();
    const href = $tab.attr('href');
    history.pushState(null, null, href);
  }
}